import { KeyboardEvent } from "react";

import { Key } from "./constants";

/**
 * Kontrola, jestli byla zmáčknuta klávesa pro smazání hodnoty atributu v hromadné editaci.
 * @param event
 */
export const isMultiEditEraseKey = (event: KeyboardEvent): boolean => event.key === Key.Backspace || event.key === Key.Delete;

/**
 * Kontrola, jestli byla zmáčknuta klávesa pro přepnutí hodnoty checkboxu.
 * @param event
 */
export const isCheckBoxSwitchKey = (event: KeyboardEvent): boolean => event.key === Key.Space;
